package us.laantech.laanmanage.util

import kotlinx.browser.document
import org.w3c.dom.HTMLAnchorElement

actual suspend fun downloadFileFromUrl(url: String, fileName: String) {
    val anchor = document.createElement("a") as HTMLAnchorElement
    anchor.href = url
    anchor.download = fileName
    document.body?.appendChild(anchor)
    anchor.click()
    document.body?.removeChild(anchor)
}
